import React, { useState } from 'react';
import {
    Img,
    ImgWrap,
    TextWrapper,
    TopLine,
    ProjectionCard,
    FormH4,
    SelectButton,
    FormInput,
    Form,
    UserProjectionInput
} from './CrewBuilderElements';
import UserProjectionCard from './UserProjectionCard';
import asset from '../../images/asset.jpg'

const UserProjectionCardDeck = ({ players, handleNext, handlePrevious, currentCard }) => {
    return (
        <>
            {
                players.map((p, ind) => (
                    <UserProjectionCard key={p.playerID} player={p} handleNext={handleNext} handlePrevious={handlePrevious} currentCard={currentCard} firstCard={p == players[0]} />
                ))}
        </>
    );
};

export default UserProjectionCardDeck;
